
import {
    SOLICITAR_ANAMNESIS_ENTREVISTA,
    SOLICITAR_ANAMNESIS_ENTREVISTA_EXITO,
    SOLICITAR_ANAMNESIS_ENTREVISTA_ERROR,
    ALMACENAR_ANAMNESIS_ENTREVISTA,
    ALMACENAR_ANAMNESIS_ENTREVISTA_EXITO,
    ALMACENAR_ANAMNESIS_ENTREVISTA_ERROR
} from '../types';

import clienteAxios from '../config/axios';

import Swal from 'sweetalert2';

import {
    setearAlerta
} from './alertaActions';


/*
====================================
SOLICITAR ENTREVISTA SEMIESTRUCTURADA
====================================
*/

export function solicitarAnamnesisEntrevistaAction(informacion) {

    return async (dispatch) => {

        dispatch(
            solicitarAnamnesisEntrevista()
        );

        try {

            const { config, payload } = informacion;

            const { data } = await clienteAxios.post(
                '/paciente/solicitarAnamnesisEntrevista',
                payload,
                config
            );

            dispatch(
                solicitarAnamnesisEntrevistaExito(data)
            );

            return data;

        } catch (error) {

            dispatch(
                solicitarAnamnesisEntrevistaError(
                    error.response?.data || {
                        msg: 'No se pudo cargar la entrevista.'
                    }
                )
            );

            /*
            Conservamos la alerta existente
            para los errores de consulta.
            */

            dispatch(
                setearAlerta({
                    msg:
                        error.response?.data?.msg ||
                        'No se pudo cargar la entrevista.'
                })
            );

            return null;

        }

    };

};


const solicitarAnamnesisEntrevista = () => ({

    type: SOLICITAR_ANAMNESIS_ENTREVISTA,

    payload: true

});


const solicitarAnamnesisEntrevistaExito = (data) => ({

    type: SOLICITAR_ANAMNESIS_ENTREVISTA_EXITO,

    payload: data

});


const solicitarAnamnesisEntrevistaError = (msg) => ({

    type: SOLICITAR_ANAMNESIS_ENTREVISTA_ERROR,

    payload: msg

});


/*
====================================
ALMACENAR ENTREVISTA SEMIESTRUCTURADA
====================================

La entrevista tiene su propio plazo
de edición libre de 24 horas.

Si el backend exige una adenda,
devolvemos requiere_adenda: true.

El componente abrirá el modal.

Solo mostramos el mensaje de éxito
cuando el backend confirmó el guardado.
====================================
*/

export function almacenarAnamnesisEntrevistaAction(informacion) {

    return async (dispatch) => {

        dispatch(
            almacenarAnamnesisEntrevista()
        );

        try {

            const { config, payload } = informacion;

            const { data } = await clienteAxios.post(
                '/paciente/almacenarAnamnesisEntrevista',
                payload,
                config
            );


            /*
            ====================================
            GUARDADO EXITOSO
            ====================================
            */

            dispatch(
                almacenarAnamnesisEntrevistaExito(data)
            );


            /*
            ====================================
            SWEETALERT DE ÉXITO
            ====================================

            Aparece tanto en un guardado dentro
            de las primeras 24 horas como en
            un guardado con adenda confirmada.

            Nunca aparece al abrir el modal.
            ====================================
            */

            Swal.fire({

                title: 'Guardado correctamente',

                text:
                    'La entrevista semiestructurada se guardó correctamente.',

                icon: 'success',

                confirmButtonText: 'Aceptar',

                confirmButtonColor: '#23AAAF'

            });


            return {

                ok: true,

                requiere_adenda: false

            };

        } catch (error) {


            /*
            ====================================
            SE REQUIERE CONFIRMAR UNA ADENDA
            ====================================

            No mostramos un error en este caso.

            El componente abrirá el modal
            conservando los datos escritos.
            ====================================
            */

            if (
                error.response?.status === 409 &&
                error.response?.data?.requiere_adenda === true
            ) {

                dispatch(
                    almacenarAnamnesisEntrevistaError(
                        error.response.data
                    )
                );

                return {

                    ok: false,

                    requiere_adenda: true

                };

            }


            /*
            ====================================
            ERROR AL GUARDAR
            ====================================

            Mostramos el mensaje específico
            que devolvió el backend.

            No mostramos un mensaje de éxito.
            ====================================
            */

            const mensaje =
                error.response?.data?.msg ||
                'No se pudo guardar la entrevista.';


            dispatch(
                almacenarAnamnesisEntrevistaError(
                    error.response?.data || {
                        msg: mensaje
                    }
                )
            );


            Swal.fire({

                title: 'No se pudo guardar',

                text: mensaje,

                icon: 'error',

                confirmButtonText: 'Aceptar',

                confirmButtonColor: '#23AAAF'

            });


            return {

                ok: false,

                requiere_adenda: false

            };

        }

    };

}


const almacenarAnamnesisEntrevista = () => ({

    type: ALMACENAR_ANAMNESIS_ENTREVISTA,

    payload: true

});


const almacenarAnamnesisEntrevistaExito = (data) => ({

    type: ALMACENAR_ANAMNESIS_ENTREVISTA_EXITO,

    payload: data

});


const almacenarAnamnesisEntrevistaError = (msg) => ({

    type: ALMACENAR_ANAMNESIS_ENTREVISTA_ERROR,

    payload: msg

});